import { render } from "./left.vue?vue&type=template&id=9bc05270&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"

import "./left.vue?vue&type=style&index=0&id=9bc05270&lang=scss&scoped=true"
import "./left.vue?vue&type=style&index=1&id=9bc05270&lang=scss"
import "./left.vue?vue&type=style&index=2&id=9bc05270&lang=scss"
import "./left.vue?vue&type=style&index=3&id=9bc05270&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc05270"]])

export default __exports__